module.exports = __webpack_public_path__ + "img/basededados.d82b398f.png";